import { Controller } from "@hotwired/stimulus";
import { debounce } from "lodash";

export default class extends Controller {
  static targets = ["query", "results"];

  connect() {
    this.search = debounce(this.search.bind(this), 300);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleResultClick = this.handleResultClick.bind(this);

    this.queryTarget.addEventListener("input", this.search);
    this.queryTarget.addEventListener("keydown", this.handleKeydown);
    this.queryTarget.addEventListener("focus", this.handleFocus);
    this.resultsTarget.addEventListener("click", this.handleResultClick);
    document.addEventListener("click", this.handleDocumentClick);
  }

  disconnect() {
    this.queryTarget.removeEventListener("input", this.search);
    this.queryTarget.removeEventListener("keydown", this.handleKeydown);
    this.queryTarget.removeEventListener("focus", this.handleFocus);
    this.resultsTarget.removeEventListener("click", this.handleResultClick);
    document.removeEventListener("click", this.handleDocumentClick);
  }

  async search() {
    const query = this.queryTarget.value.trim();

    if (query.length < 3) {
      this.hideResults();
      return;
    }

    try {
      const response = await fetch(`/search?query=${encodeURIComponent(query)}`);
      const html = await response.text();

      if (html.trim() === "") {
        this.hideResults();
      } else {
        this.resultsTarget.innerHTML = html;
        this.showResults();
      }
    } catch (error) {
      console.error("Search error:", error);
      this.hideResults();
    }
  }

  showResults() {
    this.resultsTarget.classList.add("dropdown-visible");
    this.queryTarget.setAttribute("aria-expanded", "true");
  }

  hideResults() {
    this.resultsTarget.classList.remove("dropdown-visible");
    this.queryTarget.setAttribute("aria-expanded", "false");
  }

  handleDocumentClick(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults();
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      event.preventDefault();
      this.hideResults();
      this.queryTarget.blur();
    }
  }

  handleFocus() {
    if (this.resultsTarget.innerHTML.trim() !== "" && this.queryTarget.value.trim().length >= 3) {
      this.showResults();
    }
  }

  handleResultClick(event) {
    if (event.target.closest("a")) {
      this.hideResults();
    }
  }

  select(event) {
    const selectedText = event.target.textContent;
    this.queryTarget.value = selectedText;
    this.hideResults();
  }
}
